import { MdKeyboardArrowDown } from "react-icons/md";
import "./NavbarBottom.scss";
import { FaSearch } from "react-icons/fa";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import DropDownTwo from "../navBDropdown/DropDownTwo";
import DropDownThree from "../navBDropdown/DropDownThree";
import DropDownFive from "../navBDropdown/DropDownFive";
const NavbarBottom = () => {
  const navigate = useNavigate();
  const [fix, setFix] = useState(false);

  const [dropDownTwo, setDropDownTwo] = useState(false);
  const [dropDownThree, setDropDownThree] = useState(false);
  const [dropDownFive, setDropDownFive] = useState(false);

  const handleDropDownTwo = (e) => {
    setDropDownTwo(!dropDownTwo);
    setDropDownThree(false);
    setDropDownFive(false);
  };
  const handleDropDownThree = (e) => {
    setDropDownThree(!dropDownThree);
    setDropDownTwo(false);
    setDropDownFive(false);
  };
  const handleDropDownFive = (e) => {
    setDropDownFive(!dropDownFive);
    setDropDownThree(false);
    setDropDownTwo(false);
  };

  const handleScroll = (e) => {
    if (window.scrollY >= 200) {
      setFix(true);
    } else {
      setFix(false);
    }
  };

  window.addEventListener("scroll", handleScroll);
  return (
    <div className={fix ? "navbarBottom fixed" : "navbarBottom"}>
      <div className="navbarBottomWrapper">
        {/* Home */}
        <div className="item">
          <Link to="/">
            <span style={{ color: "white" }}>Home</span>
          </Link>
        </div>

        {/* World news dropDownTwo*/}
        <div className="item" onClick={handleDropDownTwo}>
          <span>Worlds News</span>
          <MdKeyboardArrowDown size={20} />
          {dropDownTwo && <DropDownTwo />}
        </div>

        {/* National */}
        <div className="item">
          <span>National</span>
        </div>
        <div className="item">
          <span>Financial</span>
        </div>
        <div className="item">
          <span>Entertainment</span>
        </div>
        <div className="item">
          <span>Lifestyle</span>
        </div>
        <div className="item">
          <span>Technology</span>
        </div>
        <div className="item">
          <span>Travel</span>
          <MdKeyboardArrowDown size={20} />
        </div>
        <div className="item">
          <span>Sports</span>
        </div>

        {/* Category dropDownThree*/}
        <div className="item" onClick={handleDropDownThree}>
          <span>Category</span>
          <MdKeyboardArrowDown size={20} />
          {dropDownThree && <DropDownThree />}
        </div>

        {/* Pages dropDownFive*/}
        <div className="item" onClick={handleDropDownFive}>
          <span>Pages</span>
          <MdKeyboardArrowDown size={20} />
          {dropDownFive && <DropDownFive />}
        </div>

        <div className="item" onClick={() => navigate("/search")}>
          <FaSearch size={20} />
        </div>
      </div>
    </div>
  );
};
export default NavbarBottom;
